module.exports = {
	extends: [
		'/',
		'templates',
		'artForm',
		'entity',
		'controller'
	],

	config: {
		usage: 'management',
		entityContext: 'address',
		insertGranted: false,
		roleOptionScope: 'art_form',
		privilegeBase: 'artform_addresses',
	}
}